function countdownParts(endsAt, now) {
  if (!endsAt) return { label: "NO EXPIRY", state: "none" };
  if (endsAt === "lifetime") return { label: "LIFETIME", state: "lifetime" };
  const ms = new Date(endsAt).getTime() - now;
  if (isNaN(ms)) return { label: "NO EXPIRY", state: "none" };
  if (ms <= 0) return { label: "EXPIRED", state: "expired" };
  const total = Math.floor(ms / 1000);
  const pad = (n) => String(n).padStart(2, "0");
  const days = Math.floor(total / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const mins = Math.floor((total % 3600) / 60);
  const secs = total % 60;
  return {
    label: `${pad(days)}D : ${pad(hours)}H : ${pad(mins)}M : ${pad(secs)}S`,
    state: ms < 24 * 3600 * 1000 ? "soon" : "active",
  };
}

export default function CountdownTimer({ endsAt, now, tid }) {
  const part = countdownParts(endsAt, now);
  const cls = {
    active: "border-emerald-300/25 text-emerald-200",
    soon: "border-amber-300/35 text-amber-200 animate-pulse",
    expired: "border-red-400/40 text-red-300",
    lifetime: "border-white/25 text-white",
    none: "border-white/10 text-white/35",
  }[part.state];
  return (
    <div data-testid={tid} className={`inline-flex border px-3 py-2 font-mono text-[11px] tracking-[0.14em] ${cls}`}>
      {part.label}
    </div>
  );
}
